import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./TimeRangePicker.css";
import { useDateRange } from "../../context/DateRangeContext";

export default function TimeRangePicker({ className = "" }) {
  const { dateRange, setDateRange } = useDateRange();
  const { mode = "ytd", startDate, endDate } = dateRange || {};
  const now = new Date();

  /* ---------- 工具函数 ---------- */
  const toDate = (d) => (d instanceof Date ? d : new Date(d));

  const firstDayOfMonth = (d) => {
    const date = toDate(d);
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };

  const lastDayOfMonth = (d) => {
    const date = toDate(d);
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };

  const isSameMonth = (a, b) => {
    const da = toDate(a);
    const db = toDate(b);
    return (
      da.getFullYear() === db.getFullYear() &&
      da.getMonth() === db.getMonth()
    );
  };

  /* ---------- 预设切换 ---------- */
  const applyPreset = (m) => {
    const now = new Date(); // 确保使用 Date 对象
    let start, end;

    if (m === "lastMonth") {
      start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      end = new Date(now.getFullYear(), now.getMonth(), 0);
    } else if (m === "ytd") {
      start = new Date(now.getFullYear(), 0, 1);
      end = now;
    } else if (m === "lastYear") {
      const y = now.getFullYear() - 1;
      start = new Date(y, 0, 1);   // 去年 1 月 1 日
      end   = new Date(y, 11, 31); // 去年 12 月 31 日
    } else if (m === "trailing12") {
      // 默认用“上一个完整月”作为 end
      const endBase = new Date(now.getFullYear(), now.getMonth(), 0); // 上月月末
      const endDate = endBase;

      const startDate = new Date(
        endBase.getFullYear(),
        endBase.getMonth() - 11,
        1
      );

      start = startDate;
      end   = endDate;
    } else {
      // custom
      start = startDate ? firstDayOfMonth(startDate) : firstDayOfMonth(now);
      end = endDate
        ? isSameMonth(endDate, now)
          ? now
          : lastDayOfMonth(endDate)
        : now;
    }

    setDateRange({ mode: m, startDate: start, endDate: end });
  };

  /* ---------- 起始月份改变 ---------- */
  const onChangeStartMonth = (monthDate) => {
    const start = firstDayOfMonth(monthDate);
    let end = endDate ? toDate(endDate) : now;
    if (end < start) end = start;
    end = isSameMonth(end, now) ? now : lastDayOfMonth(end);
    setDateRange({ mode, startDate: start, endDate: end });
  };

  /* ---------- 结束月份改变 ---------- */
  const onChangeEndMonth = (monthDate) => {
    let endCandidate = monthDate ? toDate(monthDate) : now;
    const end = isSameMonth(endCandidate, now)
      ? now
      : lastDayOfMonth(endCandidate);
    const start = startDate
      ? firstDayOfMonth(startDate)
      : firstDayOfMonth(end);
    const finalStart = start > end ? firstDayOfMonth(end) : start;
    setDateRange({ mode, startDate: finalStart, endDate: end });
  };

  /* ---------- 显示日期（保证为 Date 类型） ---------- */
  const displayStart = startDate
    ? toDate(startDate)
    : new Date(now.getFullYear(), 0, 1);
  const displayEnd = endDate ? toDate(endDate) : now;

  /* ---------- 渲染 ---------- */
  return (
  <div className={`trp ${className}`}>
    <select
      className="trp-select trp-field"
      value={mode}
      onChange={(e) => applyPreset(e.target.value)}
    >
      <option value="lastMonth">Last month</option>
      <option value="lastYear">Last year</option> {/* ✅ 新增 */}
      <option value="ytd">This year (YTD)</option>
      <option value="trailing12">Trailing 12 months</option>
      <option value="custom">Custom months</option>
    </select>

    {mode === "custom" && (
      <div className="date-picker-group">
        <DatePicker
          selected={displayStart}
          onChange={onChangeStartMonth}
          dateFormat="yyyy-MM"
          showMonthYearPicker
          showFullMonthYearPicker
          className="trp-input"
          wrapperClassName="trp-wrapper trp-field"
          minDate={new Date(2023, 0, 1)}  // ✅ 最早 2023 年 1 月
        />
        <span className="trp-sep">to</span>
        <DatePicker
          selected={displayEnd}
          onChange={onChangeEndMonth}
          dateFormat="yyyy-MM"
          showMonthYearPicker
          showFullMonthYearPicker
          className="trp-input"
          wrapperClassName="trp-wrapper trp-field"
          minDate={new Date(2023, 0, 1)}  // ✅ 同样限制
        />
      </div>
    )}


    {/* Trailing12：1 个 */}
    {mode === "trailing12" && (
      <div className="date-picker-group">
        <DatePicker
          selected={displayEnd}               // 👈 只选 end month
          onChange={(monthDate) => {
            const end = lastDayOfMonth(monthDate);
            const start = new Date(
              end.getFullYear(),
              end.getMonth() - 11,
              1
            );
            setDateRange({ mode, startDate: start, endDate: end });
          }}
          dateFormat="yyyy-MM"
          showMonthYearPicker
          showFullMonthYearPicker
          className="trp-input"
          wrapperClassName="trp-wrapper trp-field"
          minDate={new Date(2023, 0, 1)}
          maxDate={new Date(now.getFullYear(), now.getMonth() - 1, 1)} // 不允许当前月
        />
      </div>
    )}

  </div>
);
}
